import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';
import { RestoreUserDialogProps } from '../types';

export function RestoreUserDialog({ user, isRestoring, onOpenChange, onConfirm }: RestoreUserDialogProps) {
  return (
    <AlertDialog open={!!user} onOpenChange={(open) => !open && onOpenChange(open)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Восстановить аккаунт {user?.email || `@${user?.username ?? ''}`}?</AlertDialogTitle>
          <AlertDialogDescription>
            Пользователь снова сможет войти в приложение. Его прогресс и статус подписки
            вернутся в том виде, в каком были на момент удаления.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isRestoring}>Отмена</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isRestoring}
          >
            {isRestoring && <Loader2 className="animate-spin" />}
            Восстановить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
